export default {
      id: "message-usage",
      viewBox: "0 0 38.467 31.675",
      url: __webpack_public_path__ + "svg/sprite.svg#message",
      toString: function () {
        return this.url;
      }
    }